import Plyr from "plyr";

let players = [];
const videoBtns = document.querySelectorAll(".play-video");
let consented = checkConsent();

videoBtns.forEach((btn) => {
  const wrapper = btn.closest(".video-wrapper");
  const iframe = wrapper.querySelector("iframe");
  const consentBtn = wrapper.querySelector(".external-consent");
  const consentWrapper = wrapper.querySelector(".external-consent-wrapper");
  const checkbox = wrapper.querySelector("input[type=checkbox]");
  const poster = wrapper.querySelector(".poster");
  const type = btn.dataset.type;

  if (consented.includes(type)) {
    initPlyr(iframe, false);
    btn.remove();
    poster.remove();
    consentWrapper.remove();
  } else {
    btn.addEventListener("click", (e) => {
      btn.style.display = "none";
      poster.remove();
    });

    consentBtn.addEventListener("click", (e) => {
      if (checkbox.checked) {
        let allowExternal = JSON.parse(
          sessionStorage.getItem("allowExternalMedia")
        );
        if (!allowExternal) allowExternal = [];

        allowExternal.push(type);
        setConsent(allowExternal);
        unblockPlayers(btn, type);
      }

      initPlyr(iframe, true);
      btn.remove();
      poster.remove();
      consentWrapper.remove();
    });
  }
});

function initPlyr(iframe, play) {
  const container = iframe.parentElement;
  iframe.src = iframe.dataset.src;

  var options = {
    vimeo: {
      dnt: true,
      controls: 0,
      background: 1,
    },
    settings: [],
    loadSprite: false,
    iconUrl: "/site/templates/images/plyr.svg",
  };
  if (iframe.dataset.h) options["h"] = iframe.dataset.h;

  const player = new Plyr(container, options);
  players.push(player);

  if (play) {
    player.on("ready", (event) => {
      player.play();
    });
  }

  player.on("play", (event) => {
    stopPlayers(players, player);
  });
}

function stopPlayers(players, current) {
  players.forEach((player) => {
    if (player != current) player.pause();
  });
}

function checkConsent() {
  if (!sessionStorage.getItem("allowExternalMedia")) return [];
  else return JSON.parse(sessionStorage.getItem("allowExternalMedia"));
}

function setConsent(value) {
  sessionStorage.setItem("allowExternalMedia", JSON.stringify(value));
}

function unblockPlayers(currentBtn, type) {
  let toUnblock = Array.from(videoBtns).filter((item) => {
    return item.dataset.type == type && item != currentBtn;
  });
  toUnblock.forEach((item) => {
    const w = item.closest(".video-wrapper");
    if (w) {
      const iframe = w.querySelector("iframe");
      const consentWrapper = wrapper.querySelector(".external-consent-wrapper");
      const poster = wrapper.querySelector(".poster");

      if (consentWrapper) consentWrapper.remove();
      if (poster) consentWrapper.remove();
      item.remove();
      initPlyr(iframe, false);
    }
  });
}
